/**
 * Wait cursor while scatter cut/clear (and lasso apply) finishes redrawing.
 * Nested calls use a depth count so an inner lasso does not clear an outer cut.
 */
const SCATTER_SELECTION_BUSY_CLASS = "simple-scatter-lasso-computing";

let busyDepth = 0;

export function setScatterSelectionBusyCursor(on: boolean): void {
  if (typeof document === "undefined") {
    return;
  }
  if (on) {
    busyDepth += 1;
    document.documentElement.classList.add(SCATTER_SELECTION_BUSY_CLASS);
    return;
  }
  busyDepth = Math.max(0, busyDepth - 1);
  if (busyDepth === 0) {
    document.documentElement.classList.remove(SCATTER_SELECTION_BUSY_CLASS);
  }
}

/** Run work, then drop the wait cursor after the next paint (effects + canvas). */
export function runWithScatterSelectionBusyCursor(work: () => void): void {
  setScatterSelectionBusyCursor(true);
  try {
    work();
  } finally {
    releaseScatterSelectionBusyCursorAfterPaint();
  }
}

function releaseScatterSelectionBusyCursorAfterPaint(): void {
  const release = () => setScatterSelectionBusyCursor(false);
  if (typeof requestAnimationFrame === "undefined") {
    setTimeout(release, 0);
    return;
  }
  requestAnimationFrame(() => {
    requestAnimationFrame(release);
  });
}
